import React from "react";

export function useLocalStorageHandler(namespace: string) {
  const mk = React.useCallback((k: string) => `${namespace}:${k}`, [namespace]);
  const get = React.useCallback(
    <T>(key: string, fallback: T): T => {
      if (typeof window === "undefined") return fallback;
      try {
        const raw = window.localStorage.getItem(mk(key));
        if (raw === null) return fallback;
        return JSON.parse(raw) as T;
      } catch {
        return fallback;
      }
    },
    [mk]
  );
  const set = React.useCallback(
    <T>(key: string, value: T) => {
      if (typeof window === "undefined") return;
      try {
        window.localStorage.setItem(mk(key), JSON.stringify(value));
      } catch {}
    },
    [mk]
  );
  return { get, set };
}
